import { lightGold, mediumGreen,teal } from "@styles/synchrony-core-palette.js"
//test change
const STATUS = {
  LIVE: {
    text: "LIVE",
    width: 79,
    height: 38,
    iconFillColor: lightGold,
    textFillColor: "#000",
  },
  SCHEDULED: {
    text: "SCHEDULED",
    width: 146,
    height: 38,
    iconFillColor: mediumGreen,
    textFillColor: "#FFF",
  },
  EXPIRED: {
    text: "EXPIRED",
    width: 116,
    height: 38,
    iconFillColor: "#FFF",
    textFillColor: "#34657F",
    iconStrokeColor: "#34657F",
  },
  CANCELLED: {
    text: "CANCELLED",
    width: 146,
    height: 38,
    iconFillColor: "#FFF",
    textFillColor: "#34657F",
    iconStrokeColor: "#34657F",
  },
  TEMPLATE: {
    text: "TEMPLATE",
    width: 146,
    height: 38,
    iconFillColor: teal,
    textFillColor: "#FFF",
  },
  COMPLETED: {
    text: "COMPLETED",
    width: 146,
    height: 38,
    iconFillColor: "#FFF",
    textFillColor: "#34657F",
    iconStrokeColor: "#34657F",
  },
  HISTORY: {
    text: "HISTORY",
    width: 116,
    height: 38,
    iconFillColor: "#FFF",
    textFillColor: "#34657F",
    iconStrokeColor: "#34657F",
  },
  DRAFT: {
    text: "DRAFT",
    width: 99,
    height: 38,
    iconFillColor: lightGold,
    textFillColor: "#FFF",
  },
  PENDING: {
    text: "SCHEDULED",
    width: 146,
    height: 38,
    iconFillColor: mediumGreen,
    textFillColor: "#FFF",
  },
  NEW: {
    text: "ADD",
    width: 99,
    height: 38,
    iconFillColor: lightGold,
    textFillColor: "#FFF",
  },
  UPDATED: {
    text: "UPDATE",
    width: 146,
    height: 38,
    iconFillColor: mediumGreen,
    textFillColor: "#FFF",
  },
  NEW_FILE: {
    text: "NEW",
    width: 99,
    height: 38,
    iconFillColor: teal,
    textFillColor: "#FFF",
  },
  REVERTED: {
    text: "REVERTED",
    width: 146,
    height: 38,
    iconFillColor: teal,
    textFillColor: "#FFF",
  },
  SYPI_BRC: {
    text: "SYPI COMMERCIAL",
    width: 170,
    height: 38,
    iconFillColor: "#0c4a6e",
    textFillColor: "#feb600",
    viewBoxWidth: "170",
    textStyle: "text-sm",
  },
};

const SvgIconStatus = ({
  customTheme,
  theme = "LIVE",
  width,
  height,
  enableViewBox = true,
  iconFillColor,
  textFillColor,
  iconStrokeColor,
  text,
  ...otherProps
}) => {
  const statusTheme = customTheme
    ? { width, height, iconFillColor, textFillColor, iconStrokeColor, text }
    : theme && STATUS[theme]
    ? STATUS[theme]
    : null;
  return statusTheme ? (
    <svg
      width={statusTheme.width}
      height={statusTheme.height}
      {...(enableViewBox && {
        viewBox: `0 0 ${statusTheme.viewBoxWidth || statusTheme.width} ${
          statusTheme.height
        }`,
      })}
      {...otherProps}
    >
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <path
              fill={statusTheme.iconFillColor}
              stroke={statusTheme.iconStrokeColor}
              d={`M 14 0 h ${
                statusTheme.width - 14
              } l -7 31 c -1 3 -4 6 -8 6 H0 V14 C0 6 6 0 14 0z`}
              transform="translate(-43 -428) translate(43 428.5)"
            />
            <text
              fill={statusTheme.textFillColor}
              fillOpacity=".87"
              fontFamily="SynchronySans-Medium, Synchrony Sans"
              fontSize="17"
              fontWeight="600"
              letterSpacing=".159"
              transform="translate(-43 -428) translate(43 428.5)"
            >
              <tspan x="23" y="23" className={statusTheme.textStyle}>
                {statusTheme.text}
              </tspan>
            </text>
          </g>
        </g>
      </g>
    </svg>
  ) : null;
};

export default SvgIconStatus;
